export const surfaceRadii = {
  sm: 'rounded-[2px]',
  md: 'rounded-[3px]',
  lg: 'rounded-[4px]',
  xl: 'rounded-[6px]',
  shell: 'rounded-[8px]',
  full: 'rounded-full',
} as const

export const surfaceSpacing = {
  inset: {
    compact: 'p-3',
    default: 'p-4',
    comfortable: 'p-5',
    spacious: 'p-6',
  },
  insetX: {
    compact: 'px-3',
    default: 'px-4',
    comfortable: 'px-5',
    spacious: 'px-6',
  },
  insetY: {
    compact: 'py-3',
    default: 'py-4',
    comfortable: 'py-5',
    spacious: 'py-6',
    roomy: 'py-8',
  },
  gap: {
    xs: 'gap-1',
    sm: 'gap-2',
    md: 'gap-3',
    lg: 'gap-4',
    xl: 'gap-5',
    spacious: 'gap-6',
  },
  stack: {
    compact: 'space-y-3',
    default: 'space-y-4',
    comfortable: 'space-y-5',
    spacious: 'space-y-6',
  },
  overlay: {
    default: 'p-4 md:p-5',
  },
} as const
